var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import { Caption, Table, Tbody, Td, Th, Thead, Tr, RowSelectVariant } from '@patternfly/react-table';
import { Skeleton } from '@patternfly/react-core';
const SkeletonTable = (_a) => {
    var _b;
    var { variant, borders = true, rows = 5, caption, ouiaId = 'SkeletonTable', isSelectable, isExpandable, selectVariant = RowSelectVariant.checkbox, columns, numberOfColumns } = _a, rest = __rest(_a, ["variant", "borders", "rows", "caption", "ouiaId", "isSelectable", "isExpandable", "selectVariant", "columns", "numberOfColumns"]);
    const hasCustomColumns = Array.isArray(columns);
    const rowCells = hasCustomColumns ? (_b = columns === null || columns === void 0 ? void 0 : columns.length) !== null && _b !== void 0 ? _b : 0 : numberOfColumns;
    const rowArray = [...new Array(rowCells)];
    const bodyRows = [...new Array(rows)].map((_, rowIndex) => (React.createElement(Tr, { key: rowIndex, ouiaId: `${ouiaId}-tr-${rowIndex}` },
        isExpandable && (React.createElement(Td, { "data-ouia-component-id": `${ouiaId}-td-expand-${rowIndex}`, expand: {
                rowIndex,
                isExpanded: false
            } })),
        isSelectable && (React.createElement(Td, { "data-ouia-component-id": `${ouiaId}-td-select-${rowIndex}`, select: {
                rowIndex,
                isSelected: false,
                isDisabled: true,
                variant: selectVariant
            } })),
        rowArray.map((_, colIndex) => (React.createElement(Td, { key: colIndex, "data-ouia-component-id": `${ouiaId}-td-${rowIndex}-${colIndex}` },
            React.createElement(Skeleton, null)))))));
    return (React.createElement(Table, Object.assign({ "aria-label": "Loading", variant: variant, borders: borders, ouiaId: ouiaId }, rest),
        caption && React.createElement(Caption, null, caption),
        React.createElement(Thead, { "data-ouia-component-id": `${ouiaId}-thead` },
            React.createElement(Tr, { ouiaId: `${ouiaId}-tr-head` },
                isExpandable && React.createElement(Th, { key: "expand" }),
                isSelectable && React.createElement(Th, { key: "select" }),
                hasCustomColumns
                    ? columns === null || columns === void 0 ? void 0 : columns.map((c, index) => typeof c === 'string' ? (React.createElement(Th, { key: index, "data-ouia-component-id": `${ouiaId}-th-${index}` }, c)) : (React.cloneElement(c, { key: index, 'data-ouia-component-id': `${ouiaId}-th-${index}` })))
                    : rowArray.map((_, index) => (React.createElement(Th, { key: index, "data-ouia-component-id": `${ouiaId}-th-${index}` },
                        React.createElement(Skeleton, null)))))),
        React.createElement(Tbody, { "data-ouia-component-id": `${ouiaId}-tbody` }, bodyRows)));
};
export default SkeletonTable;
